import styled from "styled-components";
import theme from "../../theme/theme";

export const MainContainer = styled.div`
width: 100%;
height: 100vh;
display: flex;
justify-content: center;
align-items: center;
margin: 0 auto;

@media (max-width: 580px) {
    justify-content: start;
    margin-top: 10%;
    flex-direction: column-reverse;
}
`;

export const InfoMainContainer = styled.div`
width: 60%;
// height: 100%;
display: flex;
flex-direction: column;
height: 100%;
align-items: center;
text-align: left;

@media (max-width: 580px) {
    margin-top: 20px;
    width: 90%;
}
`;

export const InfoContainer = styled.div`
width: 80%;
display: flex;
flex-direction: column;
justify-content: start;
margin: 20px auto;
// height: 90%;
`;


export const MainMessage = styled.p`
font-size: 80px;
color: ${theme.color.shadow};
font-weight: bold;
margin: 4px 0;

@media (max-width: 720px) {
    font-size: 60px;
}

@media (max-width: 580px) {
    font-size: 40px;
}
`;

export const ImageContainer = styled.div`
width: 40%;
height: 100%;
background-color: ${theme.color.space};
display: flex;
justify-content: center;
align-items: center;

@media (max-width: 580px) {
    width: 35%;
    height: 20%;
    margin: 0 auto;
}
`;

export const ImageStyled = styled.img`
min-width: 50%;
max-width: 70%;
height: auto;

@media (max-width: 580px) {
    max-width: 90%; 
    max-height: 90%;
    object-fit: cover;
}
`;


export const LargeButton = styled.button`
cursor: pointer;
text-decoration: none;
border-radius: 8px;
background-color: ${theme.color.space};
color: ${theme.color.white};
padding: 10px;
margin: 1em;
font-size: 1em;
width: 80%;
margin-top: 20px;
&:hover {
    color: ${theme.color.honey};
    transition: color 0.4s ease;
}
`;

export const CheklistWrapper = styled.div`
  margin-left: 24px;
`;